import styled from "@emotion/styled";
import TextField from "@mui/material/TextField";
import { LinkButton } from "components/Common/Link";

export const AddAddress = styled(LinkButton)({
	marginTop: 8,
	textDecoration: "none"
});

export const ReplacementsShipToFormTextField = styled(TextField)({
	color: "var(--text-primary)",
	input: {
		color: "var(--text-primary)",
		fontFamily: "canada-type-gibson, sans-serif",
		fontWeight: "var(--font-weight-regular)"
	},
	label: {
		color: "var(--text-secondary)",
		fontFamily: "canada-type-gibson, sans-serif",
		fontWeight: "var(--font-weight-regular)"
	},
	width: "100%"
});
